module.exports = __webpack_public_path__ + "img/16.c454acc4.png";